import { IconClose } from '@medifind/icons';
import { clearConditionFilterOption, selectConditionFilter, updateConditionFilterOption, useConditionFilter } from '@medifind/zustand';
import ConditionFilter from './ConditionFilter';

const ConditionFilterStorable = ({ ...props }) => {
  const { condition } = useConditionFilter(selectConditionFilter);
  return (
    <ConditionFilter
      inputIcon={
        condition?.value
          ? [
              {
                icon: <IconClose size="medium" />,
                onClick: clearConditionFilterOption,
                label: 'Clear Condition',
              },
            ]
          : []
      }
      prepopulate={true}
      {...props}
      selectValue={condition?.selected}
      onConditionChange={(item) => (item ? updateConditionFilterOption(item) : clearConditionFilterOption())}
    />
  );
};

export { ConditionFilterStorable as default, ConditionFilterStorable };
